import useRequestImmutable from "@shared/hooks/useRequestImmutable";
import searchApi from "@api/search";
import { useAppContext } from "@context/app";
import FallingLoading from "legacy/elements/fallingLoading";
import SearchIcon from "@svg/header/search";
import { useEffect, useState } from "react";
import { ISearchRecentInput } from "types/api/search";

interface Props {
  // eslint-disable-next-line no-unused-vars
  onChange: (e: string) => void;
  showMinimal?: boolean;
}

const SearchRecent: React.FC<Props> = ({ onChange, showMinimal }) => {
  const { data } = useRequestImmutable(searchApi.popularSearch());

  const [recentSearchs, setRecentSearchs] = useState<ISearchRecentInput | null>(
    null
  );

  useEffect(() => {
    const handleFetchRecent = async () => {
      const res = await searchApi.recentSearch().fetch();
      setRecentSearchs(res);
    };
    handleFetchRecent();
  }, []);

  const {
    user: { isLoggedIn },
  } = useAppContext();

  const handleClickOnRecentSearchs = (title: String) => {
    onChange(String(title));
  };

  return (
    <div className={showMinimal ? "" : "pt-5"}>
      {Boolean(data && recentSearchs !== null) ? (
        <>
          {!showMinimal && (
            <div
              className={`border-b border-b-fds-divider pb-5 mb-5 mx-5    ${
                !isLoggedIn ||
                !recentSearchs?.data?.recent ||
                recentSearchs?.data?.recent?.length === 0
                  ? "hidden animate-fade  opacity-0"
                  : ""
              }`}
            >
              {isLoggedIn &&
              recentSearchs &&
              recentSearchs.data?.recent?.length !== 0 ? (
                <>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center justify-center">
                      <p className="text-xs font-medium leading-5 text-fds-secondary">
                        جستجوهای اخیر
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-3  pt-3">
                    {recentSearchs.data?.recent
                      ?.slice(0, 5)
                      .map((recentSearchItem, index) => (
                        <div key={index}>
                          <p
                            className="bg-fds-secondary px-1.5  leading-7 text-sm rounded-4 cursor-pointer"
                            onClick={() =>
                              handleClickOnRecentSearchs(recentSearchItem.title)
                            }
                          >
                            {recentSearchItem.title}
                          </p>
                        </div>
                      ))}
                  </div>
                </>
              ) : null}
            </div>
          )}
          <div>
            {!showMinimal && (
              <p className="text-xs font-medium leading-5 text-fds-secondary px-5">
                جستجوهای پرطرفدار
              </p>
            )}
            <div className="flex flex-col flex-wrap gap-2 mt-2">
              {data?.data.populars
                .slice(0, 5)
                .map((popularItem: { title: String }) => (
                  <div
                    key={`index-${popularItem.title}`}
                    onClick={() => {
                      onChange(String(popularItem.title));
                    }}
                    className="py-2 px-5    w-full flex gap-2 text-fds-primary hover:bg-fds-secondary cursor-pointer"
                  >
                    <div className="text-fds-icon-secondary">
                      <SearchIcon width={20} height={20} />
                    </div>
                    <p>{popularItem.title}</p>
                  </div>
                ))}
            </div>
          </div>
        </>
      ) : (
        <FallingLoading />
      )}
    </div>
  );
};

export default SearchRecent;
